module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_multiplequestions-1e65efc0fefbb8e022f3b909f7b2a305.jpg";